import { useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtErr } from "./api";
import { MailCheck } from "lucide-react";

export default function ForgotPassword({ portal }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const loginPath = { admin: "/portal/login", caregiver: "/caregiver/login", patient: "/patient/login" }[portal] || "/portal/login";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="forgot-password-page" className="min-h-screen bg-brand-navy flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/assets/bms-logo.png" alt="BMS Health Care Services" className="h-20 w-auto mx-auto bg-white rounded-2xl p-2" />
          <h1 className="mt-6 font-display text-3xl text-white">Reset Your Password</h1>
        </div>
        <div className="rounded-2xl bg-white p-8 shadow-xl">
          {sent ? (
            <div data-testid="forgot-success" className="text-center">
              <MailCheck className="h-12 w-12 mx-auto text-brand-teal" strokeWidth={1.5} />
              <p className="mt-4 text-base text-slate-600">If an account exists for this email, a password reset link has been sent. Please check your inbox.</p>
              <Link to={loginPath} data-testid="forgot-back-login" className="mt-6 inline-block rounded-full bg-brand-teal px-6 py-3 text-base font-bold text-white hover:bg-brand-navy transition-colors duration-300">
                Back to Sign In
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-5">
              <p className="text-[15px] text-slate-600">Enter your account email and we will send you a secure reset link.</p>
              <div>
                <label htmlFor="forgot-email" className="block text-sm font-bold text-brand-navy">Email Address</label>
                <input
                  id="forgot-email"
                  data-testid="forgot-email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-2 w-full rounded-xl border border-slate-300 px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-brand-teal/60 focus:border-brand-teal"
                />
              </div>
              {error && <p data-testid="forgot-error" className="text-sm font-semibold text-red-700" role="alert">{error}</p>}
              <button
                type="submit"
                data-testid="forgot-submit"
                disabled={loading}
                className="w-full rounded-full bg-brand-teal px-6 py-3.5 text-base font-bold text-white hover:bg-brand-navy transition-colors duration-300 active:scale-95 disabled:opacity-60"
              >
                {loading ? "Sending…" : "Send Reset Link"}
              </button>
              <Link to={loginPath} data-testid="forgot-back-login" className="block text-center text-sm font-semibold text-brand-teal hover:text-brand-navy transition-colors duration-300">
                Back to Sign In
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
